var map = {
	"./Alerts/AnalystReports": [
		575,
		9,
		0,
		1,
		3,
		35,
		83
	],
	"./Alerts/AnalystReports.js": [
		575,
		9,
		0,
		1,
		3,
		35,
		83
	],
	"./Alerts/Markets": [
		576,
		9,
		0,
		33,
		5,
		29,
		324
	],
	"./Alerts/Markets.js": [
		576,
		9,
		0,
		33,
		5,
		29,
		324
	],
	"./Alerts/Markets.scss": [
		1088,
		7,
		416
	],
	"./Alerts/Overview": [
		577,
		9,
		0,
		1,
		3,
		5,
		257
	],
	"./Alerts/Overview.js": [
		577,
		9,
		0,
		1,
		3,
		5,
		257
	],
	"./Alerts/Overview.scss": [
		1089,
		7,
		417
	],
	"./Alerts/Preferences": [
		578,
		9,
		0,
		2,
		5,
		28,
		345
	],
	"./Alerts/Preferences.js": [
		578,
		9,
		0,
		2,
		5,
		28,
		345
	],
	"./Alerts/Stocks": [
		579,
		9,
		0,
		2,
		17,
		5,
		141
	],
	"./Alerts/Stocks.js": [
		579,
		9,
		0,
		2,
		17,
		5,
		141
	],
	"./Alerts/TechnicalAnalysisAlerts": [
		580,
		9,
		0,
		5,
		269
	],
	"./Alerts/TechnicalAnalysisAlerts.js": [
		580,
		9,
		0,
		5,
		269
	],
	"./Alerts/Watchlist": [
		581,
		9,
		0,
		34,
		5,
		262
	],
	"./Alerts/Watchlist.js": [
		581,
		9,
		0,
		34,
		5,
		262
	],
	"./Alerts/modules/NoEmailBanner": [
		357,
		9,
		377
	],
	"./Alerts/modules/NoEmailBanner.js": [
		357,
		9,
		377
	],
	"./Alerts/modules/NoEmailBanner.scss": [
		1055,
		7,
		418
	],
	"./Alerts/modules/NoEmailModal": [
		356,
		9,
		0,
		198
	],
	"./Alerts/modules/NoEmailModal.js": [
		356,
		9,
		0,
		198
	],
	"./Alerts/modules/analystReports/EditAnalystReportAlerts": [
		464,
		9,
		0,
		1,
		3,
		35,
		135
	],
	"./Alerts/modules/analystReports/EditAnalystReportAlerts.js": [
		464,
		9,
		0,
		1,
		3,
		35,
		135
	],
	"./Alerts/modules/analystReports/EditAnalystReportAlerts.scss": [
		1105,
		7,
		419
	],
	"./Alerts/modules/markets/EditMarketAlerts": [
		565,
		9,
		0,
		33,
		29,
		253
	],
	"./Alerts/modules/markets/EditMarketAlerts.js": [
		565,
		9,
		0,
		33,
		29,
		253
	],
	"./Alerts/modules/markets/EditMarketAlerts.scss": [
		1166,
		7,
		420
	],
	"./Alerts/modules/markets/MarketAlertInput": [
		465,
		9,
		179
	],
	"./Alerts/modules/markets/MarketAlertInput.js": [
		465,
		9,
		179
	],
	"./Alerts/modules/markets/MarketAlertInput.scss": [
		1106,
		7,
		421
	],
	"./Alerts/modules/overview/MarketAlerts": [
		466,
		9,
		1,
		3,
		150
	],
	"./Alerts/modules/overview/MarketAlerts.js": [
		466,
		9,
		1,
		3,
		150
	],
	"./Alerts/modules/overview/MarketAlerts.scss": [
		1107,
		7,
		422
	],
	"./Alerts/modules/overview/StockAlerts": [
		467,
		9,
		0,
		1,
		3,
		102
	],
	"./Alerts/modules/overview/StockAlerts.js": [
		467,
		9,
		0,
		1,
		3,
		102
	],
	"./Alerts/modules/overview/StockAlerts.scss": [
		1061,
		7,
		423
	],
	"./Alerts/modules/overview/StockAlertsSearch": [
		367,
		9,
		0,
		118
	],
	"./Alerts/modules/overview/StockAlertsSearch.js": [
		367,
		9,
		0,
		118
	],
	"./Alerts/modules/overview/WatchlistAlerts": [
		582,
		9,
		335
	],
	"./Alerts/modules/overview/WatchlistAlerts.js": [
		582,
		9,
		335
	],
	"./Alerts/modules/overview/WatchlistAlerts.scss": [
		1168,
		7,
		424
	],
	"./Alerts/modules/preferences/AlertPreferences": [
		566,
		9,
		0,
		2,
		28,
		251
	],
	"./Alerts/modules/preferences/AlertPreferences.js": [
		566,
		9,
		0,
		2,
		28,
		251
	],
	"./Alerts/modules/preferences/AlertPreferences.scss": [
		1167,
		7,
		425
	],
	"./Alerts/modules/stocks/EditStockAlerts": [
		468,
		9,
		0,
		2,
		17,
		25,
		136
	],
	"./Alerts/modules/stocks/EditStockAlerts.js": [
		468,
		9,
		0,
		2,
		17,
		25,
		136
	],
	"./Alerts/modules/stocks/EditStockAlerts.scss": [
		1090,
		7,
		426
	],
	"./Alerts/modules/stocks/StockAlertsInputsList": [
		460,
		9,
		0,
		2,
		17,
		25,
		244
	],
	"./Alerts/modules/stocks/StockAlertsInputsList.js": [
		460,
		9,
		0,
		2,
		17,
		25,
		244
	],
	"./Alerts/modules/stocks/alertTypes/AnalystReportAlerts": [
		413,
		9,
		221
	],
	"./Alerts/modules/stocks/alertTypes/AnalystReportAlerts.js": [
		413,
		9,
		221
	],
	"./Alerts/modules/stocks/alertTypes/AnnualEarningsAnnounced": [
		411,
		9,
		222
	],
	"./Alerts/modules/stocks/alertTypes/AnnualEarningsAnnounced.js": [
		411,
		9,
		222
	],
	"./Alerts/modules/stocks/alertTypes/MovingAverage": [
		404,
		9,
		192
	],
	"./Alerts/modules/stocks/alertTypes/MovingAverage.js": [
		404,
		9,
		192
	],
	"./Alerts/modules/stocks/alertTypes/NewsStories": [
		412,
		9,
		223
	],
	"./Alerts/modules/stocks/alertTypes/NewsStories.js": [
		412,
		9,
		223
	],
	"./Alerts/modules/stocks/alertTypes/PeRisesAbove": [
		401,
		9,
		0,
		2,
		199
	],
	"./Alerts/modules/stocks/alertTypes/PeRisesAbove.js": [
		401,
		9,
		0,
		2,
		199
	],
	"./Alerts/modules/stocks/alertTypes/PriceAboveBelow": [
		399,
		9,
		0,
		2,
		169
	],
	"./Alerts/modules/stocks/alertTypes/PriceAboveBelow.js": [
		399,
		9,
		0,
		2,
		169
	],
	"./Alerts/modules/stocks/alertTypes/PriceChanges": [
		403,
		9,
		163
	],
	"./Alerts/modules/stocks/alertTypes/PriceChanges.js": [
		403,
		9,
		163
	],
	"./Alerts/modules/stocks/alertTypes/PriceChangesFaster": [
		405,
		9,
		193
	],
	"./Alerts/modules/stocks/alertTypes/PriceChangesFaster.js": [
		405,
		9,
		193
	],
	"./Alerts/modules/stocks/alertTypes/PriceGap": [
		400,
		9,
		194
	],
	"./Alerts/modules/stocks/alertTypes/PriceGap.js": [
		400,
		9,
		194
	],
	"./Alerts/modules/stocks/alertTypes/QuarterlyEarningsAnnounced": [
		410,
		9,
		224
	],
	"./Alerts/modules/stocks/alertTypes/QuarterlyEarningsAnnounced.js": [
		410,
		9,
		224
	],
	"./Alerts/modules/stocks/alertTypes/ReachesNew52Week": [
		402,
		9,
		164
	],
	"./Alerts/modules/stocks/alertTypes/ReachesNew52Week.js": [
		402,
		9,
		164
	],
	"./Alerts/modules/stocks/alertTypes/RsiOverBoughtSold": [
		407,
		9,
		225
	],
	"./Alerts/modules/stocks/alertTypes/RsiOverBoughtSold.js": [
		407,
		9,
		225
	],
	"./Alerts/modules/stocks/alertTypes/RsiUnderBoughtSold": [
		408,
		9,
		226
	],
	"./Alerts/modules/stocks/alertTypes/RsiUnderBoughtSold.js": [
		408,
		9,
		226
	],
	"./Alerts/modules/stocks/alertTypes/StockAlertInput.scss": [
		1046,
		7,
		427
	],
	"./Alerts/modules/stocks/alertTypes/StockSplitAnnounced": [
		409,
		9,
		227
	],
	"./Alerts/modules/stocks/alertTypes/StockSplitAnnounced.js": [
		409,
		9,
		227
	],
	"./Alerts/modules/stocks/alertTypes/TradingVolumeExceeds": [
		406,
		9,
		195
	],
	"./Alerts/modules/stocks/alertTypes/TradingVolumeExceeds.js": [
		406,
		9,
		195
	],
	"./Alerts/modules/watchlist/EditWatchlistAlerts": [
		469,
		9,
		0,
		34,
		182
	],
	"./Alerts/modules/watchlist/EditWatchlistAlerts.js": [
		469,
		9,
		0,
		34,
		182
	],
	"./Alerts/modules/watchlist/EditWatchlistAlerts.scss": [
		1108,
		7,
		428
	],
	"./AnalystReports/AnalystReports.scss": [
		1069,
		7,
		429
	],
	"./AnalystReports/CustomSearch": [
		583,
		9,
		0,
		1,
		2,
		4,
		67
	],
	"./AnalystReports/CustomSearch.js": [
		583,
		9,
		0,
		1,
		2,
		4,
		67
	],
	"./AnalystReports/CustomSearch.scss": [
		1169,
		7,
		430
	],
	"./AnalystReports/CustomSearch/CriteriaView": [
		414,
		9,
		0,
		1,
		2,
		4,
		73
	],
	"./AnalystReports/CustomSearch/CriteriaView.js": [
		414,
		9,
		0,
		1,
		2,
		4,
		73
	],
	"./AnalystReports/CustomSearch/Industry": [
		382,
		9,
		138
	],
	"./AnalystReports/CustomSearch/Industry.js": [
		382,
		9,
		138
	],
	"./AnalystReports/CustomSearch/KeywordsRow": [
		380,
		9,
		165
	],
	"./AnalystReports/CustomSearch/KeywordsRow.js": [
		380,
		9,
		165
	],
	"./AnalystReports/CustomSearch/KeywordsRow.scss": [
		1074,
		7,
		431
	],
	"./AnalystReports/CustomSearch/KeywordsTooltip": [
		383,
		9,
		386
	],
	"./AnalystReports/CustomSearch/KeywordsTooltip.js": [
		383,
		9,
		386
	],
	"./AnalystReports/CustomSearch/PeriodRow": [
		378,
		9,
		120
	],
	"./AnalystReports/CustomSearch/PeriodRow.js": [
		378,
		9,
		120
	],
	"./AnalystReports/CustomSearch/PeriodRow.scss": [
		1073,
		7,
		432
	],
	"./AnalystReports/CustomSearch/ResultsView": [
		368,
		9,
		0,
		2,
		357,
		22,
		304
	],
	"./AnalystReports/CustomSearch/ResultsView.js": [
		368,
		9,
		0,
		2,
		357,
		22,
		304
	],
	"./AnalystReports/CustomSearch/ResultsView.scss": [
		1070,
		7,
		433
	],
	"./AnalystReports/CustomSearch/SaveSearchButton": [
		359,
		9,
		0,
		2,
		22,
		356
	],
	"./AnalystReports/CustomSearch/SaveSearchButton.js": [
		359,
		9,
		0,
		2,
		22,
		356
	],
	"./AnalystReports/CustomSearch/SaveSearchButton.scss": [
		1062,
		7,
		434
	],
	"./AnalystReports/CustomSearch/Source": [
		381,
		9,
		132
	],
	"./AnalystReports/CustomSearch/Source.js": [
		381,
		9,
		132
	],
	"./AnalystReports/CustomSearch/Source.scss": [
		1060,
		7,
		435
	],
	"./AnalystReports/CustomSearch/SymbolCompanyName": [
		379,
		9,
		0,
		7,
		363
	],
	"./AnalystReports/CustomSearch/SymbolCompanyName.js": [
		379,
		9,
		0,
		7,
		363
	],
	"./AnalystReports/Disclaimer/Disclaimer": [
		362,
		9,
		0,
		346
	],
	"./AnalystReports/Disclaimer/Disclaimer.js": [
		362,
		9,
		0,
		346
	],
	"./AnalystReports/Disclaimer/Disclaimer.scss": [
		1063,
		7,
		436
	],
	"./AnalystReports/Economics": [
		584,
		9,
		0,
		309,
		5,
		275
	],
	"./AnalystReports/Economics.js": [
		584,
		9,
		0,
		309,
		5,
		275
	],
	"./AnalystReports/Economics.scss": [
		1170,
		7,
		437
	],
	"./AnalystReports/Equities": [
		585,
		9,
		0,
		310,
		5,
		16,
		325
	],
	"./AnalystReports/Equities.js": [
		585,
		9,
		0,
		310,
		5,
		16,
		325
	],
	"./AnalystReports/Equities.scss": [
		1172,
		7,
		438
	],
	"./AnalystReports/Overview": [
		586,
		9,
		0,
		311,
		5,
		277
	],
	"./AnalystReports/Overview.js": [
		586,
		9,
		0,
		311,
		5,
		277
	],
	"./AnalystReports/Overview/MySearches": [
		472,
		9,
		336
	],
	"./AnalystReports/Overview/MySearches.js": [
		472,
		9,
		336
	],
	"./AnalystReports/Overview/MySearches.scss": [
		1109,
		7,
		439
	],
	"./AnalystReports/Overview/ResearchHighlights": [
		473,
		9,
		231
	],
	"./AnalystReports/Overview/ResearchHighlights.js": [
		473,
		9,
		231
	],
	"./AnalystReports/SavedSearches": [
		587,
		9,
		0,
		1,
		2,
		3,
		72
	],
	"./AnalystReports/SavedSearches.js": [
		587,
		9,
		0,
		1,
		2,
		3,
		72
	],
	"./AnalystReports/SavedSearches/SavedSearchList": [
		474,
		9,
		0,
		1,
		2,
		3,
		88
	],
	"./AnalystReports/SavedSearches/SavedSearchList.js": [
		474,
		9,
		0,
		1,
		2,
		3,
		88
	],
	"./AnalystReports/SavedSearches/SavedSearchList.scss": [
		1110,
		7,
		440
	],
	"./AnalystReports/SavedSearches/SavedSearchMenu": [
		415,
		9,
		0,
		1,
		2,
		3,
		149
	],
	"./AnalystReports/SavedSearches/SavedSearchMenu.js": [
		415,
		9,
		0,
		1,
		2,
		3,
		149
	],
	"./AnalystReports/SavedSearches/SavedSearchMenu.scss": [
		1091,
		7,
		441
	],
	"./AnalystReports/SavedSearchesTab": [
		588,
		9,
		372
	],
	"./AnalystReports/SavedSearchesTab.js": [
		588,
		9,
		372
	],
	"./AnalystReports/SearchCriteria": [
		470,
		9,
		0,
		1,
		2,
		4,
		71
	],
	"./AnalystReports/SearchCriteria.js": [
		470,
		9,
		0,
		1,
		2,
		4,
		71
	],
	"./EtfCentre/Charts": [
		589,
		9,
		282
	],
	"./EtfCentre/Charts.js": [
		589,
		9,
		282
	],
	"./EtfCentre/Commentary": [
		590,
		9,
		0,
		306,
		5,
		274
	],
	"./EtfCentre/Commentary.js": [
		590,
		9,
		0,
		306,
		5,
		274
	],
	"./EtfCentre/Commentary.scss": [
		1173,
		7,
		442
	],
	"./EtfCentre/Compare": [
		591,
		9,
		0,
		1,
		3,
		4,
		70
	],
	"./EtfCentre/Compare.js": [
		591,
		9,
		0,
		1,
		3,
		4,
		70
	],
	"./EtfCentre/Compare.scss": [
		1174,
		7,
		443
	],
	"./EtfCentre/EtfCentre": [
		592,
		9,
		0,
		1,
		2,
		3,
		38
	],
	"./EtfCentre/EtfCentre.js": [
		592,
		9,
		0,
		1,
		2,
		3,
		38
	],
	"./EtfCentre/EtfCentre.scss": [
		1175,
		7,
		444
	],
	"./EtfCentre/EtfCentreContextMenu": [
		352,
		9,
		1,
		3,
		174
	],
	"./EtfCentre/EtfCentreContextMenu.js": [
		352,
		9,
		1,
		3,
		174
	],
	"./EtfCentre/EtfCentreContextMenu.scss": [
		1057,
		7,
		445
	],
	"./EtfCentre/EtfCentreScreener": [
		593,
		9,
		0,
		1,
		2,
		3,
		39
	],
	"./EtfCentre/EtfCentreScreener.js": [
		593,
		9,
		0,
		1,
		2,
		3,
		39
	],
	"./EtfCentre/EtfCentreScreener.scss": [
		1176,
		7,
		446
	],
	"./EtfCentre/EtfCentreScreenerTest": [
		594,
		9,
		0,
		2,
		6,
		307,
		93
	],
	"./EtfCentre/EtfCentreScreenerTest.js": [
		594,
		9,
		0,
		2,
		6,
		307,
		93
	],
	"./EtfCentre/EtfDisclaimers": [
		363,
		9,
		0,
		337
	],
	"./EtfCentre/EtfDisclaimers.js": [
		363,
		9,
		0,
		337
	],
	"./EtfCentre/EtfDisclaimers.scss": [
		1064,
		7,
		447
	],
	"./EtfCentre/EtfHolding": [
		595,
		9,
		0,
		1,
		4,
		296,
		74
	],
	"./EtfCentre/EtfHolding.js": [
		595,
		9,
		0,
		1,
		4,
		296,
		74
	],
	"./EtfCentre/Options": [
		596,
		9,
		0,
		1,
		3,
		10,
		96
	],
	"./EtfCentre/Options.js": [
		596,
		9,
		0,
		1,
		3,
		10,
		96
	],
	"./EtfCentre/Performance": [
		597,
		9,
		1,
		4,
		21,
		263
	],
	"./EtfCentre/Performance.js": [
		597,
		9,
		1,
		4,
		21,
		263
	],
	"./EtfCentre/Portfolio": [
		598,
		9,
		1,
		4,
		11,
		26,
		139
	],
	"./EtfCentre/Portfolio.js": [
		598,
		9,
		1,
		4,
		11,
		26,
		139
	],
	"./EtfCentre/Portfolio.scss": [
		1180,
		7,
		448
	],
	"./EtfCentre/Reports": [
		599,
		9,
		2,
		12,
		31,
		344
	],
	"./EtfCentre/Reports.js": [
		599,
		9,
		2,
		12,
		31,
		344
	],
	"./EtfCentre/Reports.scss": [
		1181,
		7,
		449
	],
	"./EtfCentre/Snapshot": [
		600,
		9,
		0,
		1,
		2,
		4,
		37
	],
	"./EtfCentre/Snapshot.js": [
		600,
		9,
		0,
		1,
		2,
		4,
		37
	],
	"./EtfCentre/TechnicalAnalysis": [
		601,
		9,
		347
	],
	"./EtfCentre/TechnicalAnalysis.js": [
		601,
		9,
		347
	],
	"./EtfCentre/eftHolding.scss": [
		1177,
		7,
		450
	],
	"./EtfCentre/modules/compare/AddEtf": [
		416,
		9,
		0,
		129
	],
	"./EtfCentre/modules/compare/AddEtf.js": [
		416,
		9,
		0,
		129
	],
	"./EtfCentre/modules/compare/BasicComparison": [
		475,
		9,
		0,
		1,
		3,
		4,
		87
	],
	"./EtfCentre/modules/compare/BasicComparison.js": [
		475,
		9,
		0,
		1,
		3,
		4,
		87
	],
	"./EtfCentre/modules/compare/BasicComparison.scss": [
		1056,
		7,
		451
	],
	"./EtfCentre/modules/compare/DistributionInformation": [
		481,
		9,
		0,
		245
	],
	"./EtfCentre/modules/compare/DistributionInformation.js": [
		481,
		9,
		0,
		245
	],
	"./EtfCentre/modules/compare/FundOverview": [
		476,
		9,
		0,
		233
	],
	"./EtfCentre/modules/compare/FundOverview.js": [
		476,
		9,
		0,
		233
	],
	"./EtfCentre/modules/compare/MorningstarRatings": [
		480,
		9,
		0,
		234
	],
	"./EtfCentre/modules/compare/MorningstarRatings.js": [
		480,
		9,
		0,
		234
	],
	"./EtfCentre/modules/compare/Performance": [
		477,
		9,
		0,
		238
	],
	"./EtfCentre/modules/compare/Performance.js": [
		477,
		9,
		0,
		238
	],
	"./EtfCentre/modules/compare/Portfolio": [
		482,
		9,
		0,
		246
	],
	"./EtfCentre/modules/compare/Portfolio.js": [
		482,
		9,
		0,
		246
	],
	"./EtfCentre/modules/compare/PremiumDiscount": [
		479,
		9,
		0,
		247
	],
	"./EtfCentre/modules/compare/PremiumDiscount.js": [
		479,
		9,
		0,
		247
	],
	"./EtfCentre/modules/compare/Risk": [
		478,
		9,
		0,
		248
	],
	"./EtfCentre/modules/compare/Risk.js": [
		478,
		9,
		0,
		248
	],
	"./EtfCentre/modules/compare/SimilarEtfDropdown": [
		458,
		9,
		1,
		4,
		175
	],
	"./EtfCentre/modules/compare/SimilarEtfDropdown.js": [
		458,
		9,
		1,
		4,
		175
	],
	"./EtfCentre/modules/compare/SimilarEtfDropdown.scss": [
		1092,
		7,
		452
	],
	"./EtfCentre/modules/overview/BrowseEtfs": [
		483,
		9,
		6,
		144
	],
	"./EtfCentre/modules/overview/BrowseEtfs.js": [
		483,
		9,
		6,
		144
	],
	"./EtfCentre/modules/overview/BrowseEtfs.scss": [
		1111,
		7,
		453
	],
	"./EtfCentre/modules/overview/ETFTypeToRanksetNameMap": [
		374,
		9,
		387
	],
	"./EtfCentre/modules/overview/ETFTypeToRanksetNameMap.js": [
		374,
		9,
		387
	],
	"./EtfCentre/modules/overview/FeaturedScreens": [
		490,
		9,
		0,
		1,
		2,
		3,
		55
	],
	"./EtfCentre/modules/overview/FeaturedScreens.js": [
		490,
		9,
		0,
		1,
		2,
		3,
		55
	],
	"./EtfCentre/modules/overview/FeaturedScreens.scss": [
		1118,
		7,
		454
	],
	"./EtfCentre/modules/overview/FindSimilarEtfs": [
		484,
		9,
		1,
		4,
		240
	],
	"./EtfCentre/modules/overview/FindSimilarEtfs.js": [
		484,
		9,
		1,
		4,
		240
	],
	"./EtfCentre/modules/overview/FindSimilarEtfs.scss": [
		1112,
		7,
		455
	],
	"./EtfCentre/modules/overview/HoldingsSearch": [
		489,
		9,
		0,
		1,
		3,
		100
	],
	"./EtfCentre/modules/overview/HoldingsSearch.js": [
		489,
		9,
		0,
		1,
		3,
		100
	],
	"./EtfCentre/modules/overview/HoldingsSearch.scss": [
		1117,
		7,
		456
	],
	"./EtfCentre/modules/overview/LatestEtfCommentary": [
		485,
		9,
		0,
		367,
		148
	],
	"./EtfCentre/modules/overview/LatestEtfCommentary.js": [
		485,
		9,
		0,
		367,
		148
	],
	"./EtfCentre/modules/overview/LatestEtfCommentary.scss": [
		1113,
		7,
		457
	],
	"./EtfCentre/modules/overview/MostActive": [
		487,
		9,
		1,
		3,
		4,
		6,
		85
	],
	"./EtfCentre/modules/overview/MostActive.js": [
		487,
		9,
		1,
		3,
		4,
		6,
		85
	],
	"./EtfCentre/modules/overview/MostActive.scss": [
		1115,
		7,
		458
	],
	"./EtfCentre/modules/overview/Performers": [
		488,
		9,
		1,
		3,
		4,
		6,
		95
	],
	"./EtfCentre/modules/overview/Performers.js": [
		488,
		9,
		1,
		3,
		4,
		6,
		95
	],
	"./EtfCentre/modules/overview/Performers.scss": [
		1116,
		7,
		459
	],
	"./EtfCentre/modules/overview/TodaysMovers": [
		486,
		9,
		1,
		3,
		4,
		6,
		86
	],
	"./EtfCentre/modules/overview/TodaysMovers.js": [
		486,
		9,
		1,
		3,
		4,
		6,
		86
	],
	"./EtfCentre/modules/overview/TodaysMovers.scss": [
		1114,
		7,
		460
	],
	"./EtfCentre/modules/overview/TopThreeChart": [
		369,
		9,
		384
	],
	"./EtfCentre/modules/overview/TopThreeChart.js": [
		369,
		9,
		384
	],
	"./EtfCentre/modules/overview/TopThreeCharts": [
		373,
		9,
		343
	],
	"./EtfCentre/modules/overview/TopThreeCharts.js": [
		373,
		9,
		343
	],
	"./EtfCentre/modules/overview/TopThreeCharts.scss": [
		1076,
		7,
		461
	],
	"./EtfCentre/modules/performance/AnnualPerformance": [
		572,
		9,
		1,
		4,
		21
	],
	"./EtfCentre/modules/performance/AnnualPerformance.js": [
		572,
		9,
		1,
		4,
		21
	],
	"./EtfCentre/modules/performance/AnnualPerformance.scss": [
		1178,
		7,
		462
	],
	"./EtfCentre/modules/performance/AnnualizedReturns": [
		499,
		9,
		1,
		4,
		122
	],
	"./EtfCentre/modules/performance/AnnualizedReturns.js": [
		499,
		9,
		1,
		4,
		122
	],
	"./EtfCentre/modules/performance/AnnualizedReturns.scss": [
		1124,
		7,
		463
	],
	"./EtfCentre/modules/performance/Growth10KChart": [
		459,
		9,
		290
	],
	"./EtfCentre/modules/performance/Growth10KChart.js": [
		459,
		9,
		290
	],
	"./EtfCentre/modules/performance/Growth10KChart.scss": [
		1093,
		7,
		464
	],
	"./EtfCentre/modules/performance/MorningstarRiskRating": [
		498,
		9,
		1,
		4,
		130
	],
	"./EtfCentre/modules/performance/MorningstarRiskRating.js": [
		498,
		9,
		1,
		4,
		130
	],
	"./EtfCentre/modules/performance/MorningstarRiskRating.scss": [
		1122,
		7,
		465
	],
	"./EtfCentre/modules/performance/TrailingReturnsChart": [
		558,
		9,
		1,
		4,
		121
	],
	"./EtfCentre/modules/performance/TrailingReturnsChart.js": [
		558,
		9,
		1,
		4,
		121
	],
	"./EtfCentre/modules/performance/TrailingReturnsChart.scss": [
		1123,
		7,
		466
	],
	"./EtfCentre/modules/performance/Volatility": [
		500,
		9,
		1,
		4,
		140
	],
	"./EtfCentre/modules/performance/Volatility.js": [
		500,
		9,
		1,
		4,
		140
	],
	"./EtfCentre/modules/performance/Volatility.scss": [
		1125,
		7,
		467
	],
	"./EtfCentre/modules/portfolio/AssetAllocation": [
		501,
		9,
		11,
		268
	],
	"./EtfCentre/modules/portfolio/AssetAllocation.js": [
		501,
		9,
		11,
		268
	],
	"./EtfCentre/modules/portfolio/AssetAllocation.scss": [
		1126,
		7,
		468
	],
	"./EtfCentre/modules/portfolio/TopGlobalHoldings": [
		502,
		9,
		1,
		4,
		119
	],
	"./EtfCentre/modules/portfolio/TopGlobalHoldings.js": [
		502,
		9,
		1,
		4,
		119
	],
	"./EtfCentre/modules/portfolio/TopGlobalHoldings.scss": [
		1127,
		7,
		469
	],
	"./EtfCentre/modules/portfolio/TopHoldings": [
		503,
		9,
		11,
		265
	],
	"./EtfCentre/modules/portfolio/TopHoldings.js": [
		503,
		9,
		11,
		265
	],
	"./EtfCentre/modules/portfolio/TopHoldings.scss": [
		1128,
		7,
		470
	],
	"./EtfCentre/modules/portfolio/TopSectorHoldings": [
		567,
		9,
		11,
		26
	],
	"./EtfCentre/modules/portfolio/TopSectorHoldings.js": [
		567,
		9,
		11,
		26
	],
	"./EtfCentre/modules/portfolio/TopSectorHoldings.scss": [
		1179,
		7,
		471
	],
	"./EtfCentre/modules/reports/EtfHoldingNews": [
		568,
		9,
		2,
		12,
		31
	],
	"./EtfCentre/modules/reports/EtfHoldingNews.js": [
		568,
		9,
		2,
		12,
		31
	],
	"./EtfCentre/modules/reports/EtfNews": [
		505,
		9,
		2,
		12,
		342
	],
	"./EtfCentre/modules/reports/EtfNews.js": [
		505,
		9,
		2,
		12,
		342
	],
	"./EtfCentre/modules/reports/MorningstarAnalystReport": [
		504,
		9,
		243
	],
	"./EtfCentre/modules/reports/MorningstarAnalystReport.js": [
		504,
		9,
		243
	],
	"./EtfCentre/modules/reports/MorningstarAnalystReport.scss": [
		1129,
		7,
		472
	],
	"./EtfCentre/modules/screener/AddCriteria": [
		495,
		9,
		0,
		2,
		7,
		8,
		84
	],
	"./EtfCentre/modules/screener/AddCriteria.js": [
		495,
		9,
		0,
		2,
		7,
		8,
		84
	],
	"./EtfCentre/modules/screener/AddCriteria.scss": [
		1120,
		7,
		473
	],
	"./EtfCentre/modules/screener/CriteriaCard": [
		497,
		9,
		2,
		176
	],
	"./EtfCentre/modules/screener/CriteriaCard.js": [
		497,
		9,
		2,
		176
	],
	"./EtfCentre/modules/screener/CriteriaCard.scss": [
		1121,
		7,
		474
	],
	"./EtfCentre/modules/screener/CustomScreener": [
		493,
		9,
		0,
		1,
		2,
		3,
		46
	],
	"./EtfCentre/modules/screener/CustomScreener.js": [
		493,
		9,
		0,
		1,
		2,
		3,
		46
	],
	"./EtfCentre/modules/screener/CustomScreener.scss": [
		1085,
		7,
		475
	],
	"./EtfCentre/modules/screener/FeaturedScreens": [
		491,
		9,
		0,
		1,
		2,
		3,
		48
	],
	"./EtfCentre/modules/screener/FeaturedScreens.js": [
		491,
		9,
		0,
		1,
		2,
		3,
		48
	],
	"./EtfCentre/modules/screener/QuickScreener": [
		492,
		9,
		0,
		1,
		2,
		3,
		47
	],
	"./EtfCentre/modules/screener/QuickScreener.js": [
		492,
		9,
		0,
		1,
		2,
		3,
		47
	],
	"./EtfCentre/modules/screener/SavedScreenMenu": [
		417,
		9,
		0,
		1,
		2,
		3,
		123
	],
	"./EtfCentre/modules/screener/SavedScreenMenu.js": [
		417,
		9,
		0,
		1,
		2,
		3,
		123
	],
	"./EtfCentre/modules/screener/SavedScreenTab": [
		496,
		9,
		388
	],
	"./EtfCentre/modules/screener/SavedScreenTab.js": [
		496,
		9,
		388
	],
	"./EtfCentre/modules/screener/SavedScreens": [
		494,
		9,
		0,
		1,
		2,
		3,
		49
	],
	"./EtfCentre/modules/screener/SavedScreens.js": [
		494,
		9,
		0,
		1,
		2,
		3,
		49
	],
	"./EtfCentre/modules/screener/SavedScreens.scss": [
		1077,
		7,
		476
	],
	"./EtfCentre/modules/screener/ScreenerCriteria": [
		375,
		9,
		0,
		1,
		2,
		4,
		63
	],
	"./EtfCentre/modules/screener/ScreenerCriteria.js": [
		375,
		9,
		0,
		1,
		2,
		4,
		63
	],
	"./EtfCentre/modules/screener/featuredScreens.scss": [
		1119,
		7,
		477
	],
	"./EtfCentre/modules/screener/modules/FeaturedScreensConfig": [
		370,
		9,
		389
	],
	"./EtfCentre/modules/screener/modules/FeaturedScreensConfig.js": [
		370,
		9,
		389
	],
	"./EtfCentre/modules/snapshot/DistributionInfo": [
		511,
		9,
		285
	],
	"./EtfCentre/modules/snapshot/DistributionInfo.js": [
		511,
		9,
		285
	],
	"./EtfCentre/modules/snapshot/DistributionInfo.scss": [
		1136,
		7,
		478
	],
	"./EtfCentre/modules/snapshot/FundOverview": [
		507,
		9,
		0,
		1,
		2,
		4,
		58
	],
	"./EtfCentre/modules/snapshot/FundOverview.js": [
		507,
		9,
		0,
		1,
		2,
		4,
		58
	],
	"./EtfCentre/modules/snapshot/FundOverview.scss": [
		1131,
		7,
		479
	],
	"./EtfCentre/modules/snapshot/Fundamentals": [
		509,
		9,
		339
	],
	"./EtfCentre/modules/snapshot/Fundamentals.js": [
		509,
		9,
		339
	],
	"./EtfCentre/modules/snapshot/Fundamentals.scss": [
		1133,
		7,
		480
	],
	"./EtfCentre/modules/snapshot/MorningstarReports": [
		510,
		9,
		249
	],
	"./EtfCentre/modules/snapshot/MorningstarReports.js": [
		510,
		9,
		249
	],
	"./EtfCentre/modules/snapshot/MorningstarReports.scss": [
		1134,
		7,
		481
	],
	"./EtfCentre/modules/snapshot/Portfolio": [
		512,
		9,
		1,
		4,
		11,
		110
	],
	"./EtfCentre/modules/snapshot/Portfolio.js": [
		512,
		9,
		1,
		4,
		11,
		110
	],
	"./EtfCentre/modules/snapshot/Portfolio.scss": [
		1137,
		7,
		482
	],
	"./EtfCentre/modules/snapshot/PremiumDiscount": [
		506,
		9,
		321
	],
	"./EtfCentre/modules/snapshot/PremiumDiscount.js": [
		506,
		9,
		321
	],
	"./EtfCentre/modules/snapshot/PremiumDiscount.scss": [
		1130,
		7,
		483
	],
	"./EtfCentre/modules/snapshot/PremiumDiscountChart": [
		559,
		9,
		1,
		4,
		142
	],
	"./EtfCentre/modules/snapshot/PremiumDiscountChart.js": [
		559,
		9,
		1,
		4,
		142
	],
	"./EtfCentre/modules/snapshot/PremiumDiscountChart.scss": [
		1135,
		7,
		484
	],
	"./EtfCentre/modules/snapshot/PremiumDiscountChartHover": [
		419,
		9,
		390
	],
	"./EtfCentre/modules/snapshot/PremiumDiscountChartHover.js": [
		419,
		9,
		390
	],
	"./EtfCentre/modules/snapshot/SimilarETFs": [
		508,
		9,
		0,
		1,
		4,
		351,
		108
	],
	"./EtfCentre/modules/snapshot/SimilarETFs.js": [
		508,
		9,
		0,
		1,
		4,
		351,
		108
	],
	"./EtfCentre/modules/snapshot/SimilarETFs.scss": [
		1132,
		7,
		485
	],
	"./FundCentre/Charts": [
		602,
		9,
		278
	],
	"./FundCentre/Charts.js": [
		602,
		9,
		278
	],
	"./FundCentre/CustomizeScreener": [
		603,
		9,
		0,
		1,
		2,
		3,
		40
	],
	"./FundCentre/CustomizeScreener.js": [
		603,
		9,
		0,
		1,
		2,
		3,
		40
	],
	"./FundCentre/FundCentreCustomizeScreeners": [
		513,
		9,
		0,
		1,
		2,
		3,
		43
	],
	"./FundCentre/FundCentreCustomizeScreeners.js": [
		513,
		9,
		0,
		1,
		2,
		3,
		43
	],
	"./FundCentre/FundCentreCustomizeScreeners.scss": [
		1138,
		7,
		486
	],
	"./FundCentre/FundCentreDisclaimers": [
		365,
		9,
		0,
		323
	],
	"./FundCentre/FundCentreDisclaimers.js": [
		365,
		9,
		0,
		323
	],
	"./FundCentre/FundCentreDisclaimers.scss": [
		1065,
		7,
		487
	],
	"./FundCentre/FundCentreEtfs": [
		604,
		9,
		0,
		6,
		292,
		5,
		270
	],
	"./FundCentre/FundCentreEtfs.js": [
		604,
		9,
		0,
		6,
		292,
		5,
		270
	],
	"./FundCentre/FundCentreHolding": [
		605,
		9,
		0,
		1,
		4,
		297,
		75
	],
	"./FundCentre/FundCentreHolding.js": [
		605,
		9,
		0,
		1,
		4,
		297,
		75
	],
	"./FundCentre/FundCentreHolding.scss": [
		1182,
		7,
		488
	],
	"./FundCentre/FundCentreOverview": [
		606,
		9,
		0,
		6,
		312,
		5,
		260
	],
	"./FundCentre/FundCentreOverview.js": [
		606,
		9,
		0,
		6,
		312,
		5,
		260
	],
	"./FundCentre/FundCentreOverview.scss": [
		1071,
		7,
		489
	],
	"./FundCentre/FundCentrePerformance": [
		607,
		9,
		0,
		6,
		300,
		5,
		254
	],
	"./FundCentre/FundCentrePerformance.js": [
		607,
		9,
		0,
		6,
		300,
		5,
		254
	],
	"./FundCentre/FundCentrePerformance.scss": [
		1183,
		7,
		490
	],
	"./FundCentre/FundCentreScreeners": [
		608,
		9,
		0,
		1,
		2,
		3,
		41
	],
	"./FundCentre/FundCentreScreeners.js": [
		608,
		9,
		0,
		1,
		2,
		3,
		41
	],
	"./FundCentre/FundCentreScreeners.scss": [
		1139,
		7,
		491
	],
	"./FundCentre/HoldingPerformance": [
		609,
		9,
		15,
		273
	],
	"./FundCentre/HoldingPerformance.js": [
		609,
		9,
		15,
		273
	],
	"./FundCentre/LipperLeaders": [
		610,
		9,
		1,
		4,
		20,
		391
	],
	"./FundCentre/LipperLeaders.js": [
		610,
		9,
		1,
		4,
		20,
		391
	],
	"./FundCentre/Options": [
		611,
		9,
		0,
		1,
		3,
		10,
		97
	],
	"./FundCentre/Options.js": [
		611,
		9,
		0,
		1,
		3,
		10,
		97
	],
	"./FundCentre/Portfolio": [
		612,
		9,
		11,
		27,
		359
	],
	"./FundCentre/Portfolio.js": [
		612,
		9,
		11,
		27,
		359
	],
	"./FundCentre/Screener/AdditionalFundAttributesCriteriaTable": [
		397,
		9,
		0,
		1,
		2,
		4,
		65
	],
	"./FundCentre/Screener/AdditionalFundAttributesCriteriaTable.js": [
		397,
		9,
		0,
		1,
		2,
		4,
		65
	],
	"./FundCentre/Screener/CibcFunds": [
		521,
		9,
		0,
		2,
		7,
		8,
		81
	],
	"./FundCentre/Screener/CibcFunds.js": [
		521,
		9,
		0,
		2,
		7,
		8,
		81
	],
	"./FundCentre/Screener/CibcFunds.scss": [
		1143,
		7,
		492
	],
	"./FundCentre/Screener/CibcFundsConfig": [
		422,
		9,
		0,
		2,
		7,
		8,
		89
	],
	"./FundCentre/Screener/CibcFundsConfig.js": [
		422,
		9,
		0,
		2,
		7,
		8,
		89
	],
	"./FundCentre/Screener/CustomizeScreenerCriteria": [
		421,
		9,
		0,
		1,
		2,
		4,
		56
	],
	"./FundCentre/Screener/CustomizeScreenerCriteria.js": [
		421,
		9,
		0,
		1,
		2,
		4,
		56
	],
	"./FundCentre/Screener/CustomizeScreenerResults": [
		420,
		9,
		0,
		1,
		2,
		3,
		53
	],
	"./FundCentre/Screener/CustomizeScreenerResults.js": [
		420,
		9,
		0,
		1,
		2,
		3,
		53
	],
	"./FundCentre/Screener/FundCriteriaTable": [
		388,
		9,
		0,
		1,
		2,
		4,
		59
	],
	"./FundCentre/Screener/FundCriteriaTable.js": [
		388,
		9,
		0,
		1,
		2,
		4,
		59
	],
	"./FundCentre/Screener/FundCriteriaTable.scss": [
		1058,
		7,
		493
	],
	"./FundCentre/Screener/LipperLeaderRatingsCrieriaTable": [
		390,
		9,
		0,
		1,
		2,
		4,
		60
	],
	"./FundCentre/Screener/LipperLeaderRatingsCrieriaTable.js": [
		390,
		9,
		0,
		1,
		2,
		4,
		60
	],
	"./FundCentre/Screener/Prescreens": [
		516,
		9,
		364
	],
	"./FundCentre/Screener/Prescreens.js": [
		516,
		9,
		364
	],
	"./FundCentre/Screener/SavedScreenMenu": [
		423,
		9,
		0,
		1,
		3,
		200
	],
	"./FundCentre/Screener/SavedScreenMenu.js": [
		423,
		9,
		0,
		1,
		3,
		200
	],
	"./FundCentre/Screener/SavedScreens": [
		522,
		9,
		0,
		1,
		3,
		6,
		117
	],
	"./FundCentre/Screener/SavedScreens.js": [
		522,
		9,
		0,
		1,
		3,
		6,
		117
	],
	"./FundCentre/Screener/SavedScreens.scss": [
		1080,
		7,
		494
	],
	"./FundCentre/Screener/TotalReturnPerformanceCriteriaTable": [
		389,
		9,
		0,
		1,
		2,
		4,
		61
	],
	"./FundCentre/Screener/TotalReturnPerformanceCriteriaTable.js": [
		389,
		9,
		0,
		1,
		2,
		4,
		61
	],
	"./FundCentre/Screener/criteria/LFFundType": [
		297,
		9,
		204
	],
	"./FundCentre/Screener/criteria/LFFundType.js": [
		297,
		9,
		204
	],
	"./FundCentre/Screener/criteria/LFFundType.scss": [
		1038,
		7,
		495
	],
	"./FundCentre/Screener/criteria/LFLoadType": [
		296,
		9,
		186
	],
	"./FundCentre/Screener/criteria/LFLoadType.js": [
		296,
		9,
		186
	],
	"./FundCentre/Screener/criteria/LFMgmtExpenseRatio": [
		295,
		9,
		187
	],
	"./FundCentre/Screener/criteria/LFMgmtExpenseRatio.js": [
		295,
		9,
		187
	],
	"./FundCentre/Screener/criteria/LFMinInitialInvest": [
		293,
		9,
		188
	],
	"./FundCentre/Screener/criteria/LFMinInitialInvest.js": [
		293,
		9,
		188
	],
	"./FundCentre/Screener/criteria/LFTotalNetAssets": [
		294,
		9,
		189
	],
	"./FundCentre/Screener/criteria/LFTotalNetAssets.js": [
		294,
		9,
		189
	],
	"./FundCentre/Snapshot": [
		613,
		9,
		1,
		4,
		15,
		91
	],
	"./FundCentre/Snapshot.js": [
		613,
		9,
		1,
		4,
		15,
		91
	],
	"./FundCentre/modules/etfs/ExchangeTradedFunds": [
		514,
		9,
		6,
		104
	],
	"./FundCentre/modules/etfs/ExchangeTradedFunds.js": [
		514,
		9,
		6,
		104
	],
	"./FundCentre/modules/etfs/ExchangeTradedFunds.scss": [
		1140,
		7,
		496
	],
	"./FundCentre/modules/holding_performance/ContactInfo": [
		525,
		9,
		369
	],
	"./FundCentre/modules/holding_performance/ContactInfo.js": [
		525,
		9,
		369
	],
	"./FundCentre/modules/holding_performance/ContactInfo.scss": [
		1145,
		7,
		497
	],
	"./FundCentre/modules/holding_performance/Distribution": [
		524,
		9,
		333
	],
	"./FundCentre/modules/holding_performance/Distribution.js": [
		524,
		9,
		333
	],
	"./FundCentre/modules/holding_performance/Distribution.scss": [
		1144,
		7,
		498
	],
	"./FundCentre/modules/lipperLeaders/LipperLeadersRatings": [
		569,
		9,
		1,
		4,
		20
	],
	"./FundCentre/modules/lipperLeaders/LipperLeadersRatings.js": [
		569,
		9,
		1,
		4,
		20
	],
	"./FundCentre/modules/lipperLeaders/LipperLeadersRatings.scss": [
		1185,
		7,
		499
	],
	"./FundCentre/modules/overview/CIBCFunds": [
		614,
		9,
		365
	],
	"./FundCentre/modules/overview/CIBCFunds.js": [
		614,
		9,
		365
	],
	"./FundCentre/modules/overview/SavedScreens": [
		517,
		9,
		6,
		313
	],
	"./FundCentre/modules/overview/SavedScreens.js": [
		517,
		9,
		6,
		313
	],
	"./FundCentre/modules/overview/SavedScreens.scss": [
		1141,
		7,
		500
	],
	"./FundCentre/modules/overview/TodaysFunds": [
		515,
		9,
		6,
		126
	],
	"./FundCentre/modules/overview/TodaysFunds.js": [
		515,
		9,
		6,
		126
	],
	"./FundCentre/modules/overview/TodaysFunds.scss": [
		1086,
		7,
		501
	],
	"./FundCentre/modules/overview/TodaysIndices": [
		560,
		9,
		137
	],
	"./FundCentre/modules/overview/TodaysIndices.js": [
		560,
		9,
		137
	],
	"./FundCentre/modules/performance/LipperLeaders": [
		518,
		9,
		6,
		106
	],
	"./FundCentre/modules/performance/LipperLeaders.js": [
		518,
		9,
		6,
		106
	],
	"./FundCentre/modules/performance/LipperLeaders.scss": [
		1142,
		7,
		502
	],
	"./FundCentre/modules/performance/MutualFunds": [
		519,
		9,
		6,
		114
	],
	"./FundCentre/modules/performance/MutualFunds.js": [
		519,
		9,
		6,
		114
	],
	"./FundCentre/modules/performance/MutualFunds.scss": [
		1087,
		7,
		503
	],
	"./FundCentre/modules/performance/TotalNetAssets": [
		520,
		9,
		6,
		115
	],
	"./FundCentre/modules/performance/TotalNetAssets.js": [
		520,
		9,
		6,
		115
	],
	"./FundCentre/modules/portfolio/AssetAllocation": [
		570,
		9,
		11,
		27
	],
	"./FundCentre/modules/portfolio/AssetAllocation.js": [
		570,
		9,
		11,
		27
	],
	"./FundCentre/modules/portfolio/AssetAllocation.scss": [
		1186,
		7,
		504
	],
	"./FundCentre/modules/snapshot/DividendInformation": [
		527,
		9,
		332
	],
	"./FundCentre/modules/snapshot/DividendInformation.js": [
		527,
		9,
		332
	],
	"./FundCentre/modules/snapshot/DividendInformation.scss": [
		1147,
		7,
		505
	],
	"./FundCentre/modules/snapshot/FundObjective": [
		424,
		9,
		360
	],
	"./FundCentre/modules/snapshot/FundObjective.js": [
		424,
		9,
		360
	],
	"./FundCentre/modules/snapshot/FundObjective.scss": [
		1096,
		7,
		506
	],
	"./FundCentre/modules/snapshot/FundQuoteDetails": [
		526,
		9,
		334
	],
	"./FundCentre/modules/snapshot/FundQuoteDetails.js": [
		526,
		9,
		334
	],
	"./FundCentre/modules/snapshot/FundQuoteDetails.scss": [
		1146,
		7,
		507
	],
	"./FundCentre/modules/snapshot/PortfolioAllocation": [
		425,
		9,
		286
	],
	"./FundCentre/modules/snapshot/PortfolioAllocation.js": [
		425,
		9,
		286
	],
	"./FundCentre/modules/snapshot/PortfolioAllocation.scss": [
		1097,
		7,
		508
	],
	"./FundCentre/modules/snapshot/PurchaseDetails": [
		528,
		9,
		1,
		4,
		232
	],
	"./FundCentre/modules/snapshot/PurchaseDetails.js": [
		528,
		9,
		1,
		4,
		232
	],
	"./FundCentre/modules/snapshot/TotalReturnPerformance": [
		523,
		9,
		15
	],
	"./FundCentre/modules/snapshot/TotalReturnPerformance.js": [
		523,
		9,
		15
	],
	"./FundCentre/modules/snapshot/TotalReturnPerformance.scss": [
		1184,
		7,
		509
	],
	"./MarketsCentre/MarketMovers": [
		615,
		9,
		0,
		1,
		3,
		5,
		258
	],
	"./MarketsCentre/MarketMovers.js": [
		615,
		9,
		0,
		1,
		3,
		5,
		258
	],
	"./MarketsCentre/MarketTechnicalAnalysis": [
		616,
		9,
		0,
		5,
		287
	],
	"./MarketsCentre/MarketTechnicalAnalysis.js": [
		616,
		9,
		0,
		5,
		287
	],
	"./MarketsCentre/Markets.scss": [
		1187,
		7,
		510
	],
	"./MarketsCentre/MarketsGlance": [
		617,
		9,
		0,
		293,
		5,
		255
	],
	"./MarketsCentre/MarketsGlance.js": [
		617,
		9,
		0,
		293,
		5,
		255
	],
	"./MarketsCentre/MarketsNews": [
		618,
		9,
		0,
		2,
		5,
		30,
		291
	],
	"./MarketsCentre/MarketsNews.js": [
		618,
		9,
		0,
		2,
		5,
		30,
		291
	],
	"./MarketsCentre/MarketsNews.scss": [
		1188,
		7,
		511
	],
	"./MarketsCentre/MarketsOverview": [
		619,
		9,
		0,
		2,
		280,
		5,
		167
	],
	"./MarketsCentre/MarketsOverview.js": [
		619,
		9,
		0,
		2,
		280,
		5,
		167
	],
	"./MarketsCentre/Modules/MarketMovers/MarketMoversModule": [
		529,
		9,
		1,
		3,
		32,
		131
	],
	"./MarketsCentre/Modules/MarketMovers/MarketMoversModule.js": [
		529,
		9,
		1,
		3,
		32,
		131
	],
	"./MarketsCentre/Modules/MarketMovers/MarketMoversModule.scss": [
		1148,
		7,
		512
	],
	"./MarketsCentre/Modules/MarketMovers/MarketMoversTable": [
		461,
		9,
		1,
		3,
		32,
		242
	],
	"./MarketsCentre/Modules/MarketMovers/MarketMoversTable.js": [
		461,
		9,
		1,
		3,
		32,
		242
	],
	"./MarketsCentre/Modules/MarketsAtAGlance/CommoditiesInDollars": [
		557,
		9,
		283
	],
	"./MarketsCentre/Modules/MarketsAtAGlance/CommoditiesInDollars.js": [
		557,
		9,
		283
	],
	"./MarketsCentre/Modules/MarketsAtAGlance/KeyRates": [
		531,
		9,
		354
	],
	"./MarketsCentre/Modules/MarketsAtAGlance/KeyRates.js": [
		531,
		9,
		354
	],
	"./MarketsCentre/Modules/MarketsAtAGlance/KeyRates.scss": [
		1150,
		7,
		513
	],
	"./MarketsCentre/Modules/MarketsAtAGlance/NorthAmericanMarkets": [
		530,
		9,
		266
	],
	"./MarketsCentre/Modules/MarketsAtAGlance/NorthAmericanMarkets.js": [
		530,
		9,
		266
	],
	"./MarketsCentre/Modules/MarketsAtAGlance/NorthAmericanMarkets.scss": [
		1149,
		7,
		514
	],
	"./MarketsCentre/Modules/MarketsInsights/InsightsAccountOverview": [
		650,
		9,
		196
	],
	"./MarketsCentre/Modules/MarketsInsights/InsightsAccountOverview.js": [
		650,
		9,
		196
	],
	"./MarketsCentre/Modules/MarketsInsights/InsightsAccountOverview.scss": [
		1189,
		7,
		515
	],
	"./MarketsCentre/Modules/MarketsNews/MarketsNewsHeadlines": [
		651,
		9,
		302
	],
	"./MarketsCentre/Modules/MarketsNews/MarketsNewsHeadlines.js": [
		651,
		9,
		302
	],
	"./MarketsCentre/Modules/MarketsNews/MarketsNewsHeadlines.scss": [
		1190,
		7,
		516
	],
	"./MarketsCentre/Modules/MarketsOverviewBanner/MarketsOverviewBanner": [
		649,
		9,
		322
	],
	"./MarketsCentre/Modules/MarketsOverviewBanner/MarketsOverviewBanner.js": [
		649,
		9,
		322
	],
	"./MarketsCentre/Modules/MarketsOverviewBanner/MarketsOverviewBanner.scss": [
		1191,
		7,
		517
	],
	"./MarketsCentre/Modules/Overview/Insights": [
		620,
		9,
		184
	],
	"./MarketsCentre/Modules/Overview/Insights.js": [
		620,
		9,
		184
	],
	"./MarketsCentre/Modules/Overview/Insights.scss": [
		1192,
		7,
		518
	],
	"./MarketsCentre/Modules/Overview/MarketMovers": [
		533,
		9,
		315
	],
	"./MarketsCentre/Modules/Overview/MarketMovers.js": [
		533,
		9,
		315
	],
	"./MarketsCentre/Modules/Overview/MarketMovers.scss": [
		1153,
		7,
		519
	],
	"./MarketsCentre/Modules/Overview/MarketsOverview": [
		532,
		9,
		267
	],
	"./MarketsCentre/Modules/Overview/MarketsOverview.js": [
		532,
		9,
		267
	],
	"./MarketsCentre/Modules/Overview/MarketsOverview.scss": [
		1152,
		7,
		520
	],
	"./Quotelists/CreateEditWatchlist": [
		621,
		9,
		0,
		2,
		299,
		5,
		305
	],
	"./Quotelists/CreateEditWatchlist.js": [
		621,
		9,
		0,
		2,
		299,
		5,
		305
	],
	"./Quotelists/CreateEditWatchlist.scss": [
		1193,
		7,
		521
	],
	"./Quotelists/Modules/CreateEditTable": [
		535,
		9,
		0,
		168
	],
	"./Quotelists/Modules/CreateEditTable.js": [
		535,
		9,
		0,
		168
	],
	"./Quotelists/Modules/EditPurchaseDetails": [
		391,
		9,
		0,
		2,
		124
	],
	"./Quotelists/Modules/EditPurchaseDetails.js": [
		391,
		9,
		0,
		2,
		124
	],
	"./Quotelists/Modules/Quotelist/MutualFunds": [
		536,
		9,
		0,
		1,
		3,
		13,
		256
	],
	"./Quotelists/Modules/Quotelist/MutualFunds.js": [
		536,
		9,
		0,
		1,
		3,
		13,
		256
	],
	"./Quotelists/Modules/Quotelist/MutualFunds.scss": [
		1154,
		7,
		522
	],
	"./Quotelists/Modules/Quotelist/MutualFundsTableBuilders": [
		622,
		7,
		392
	],
	"./Quotelists/Modules/Quotelist/MutualFundsTableBuilders.js": [
		622,
		7,
		392
	],
	"./Quotelists/Modules/Quotelist/Options": [
		561,
		9,
		0,
		1,
		3,
		10,
		76
	],
	"./Quotelists/Modules/Quotelist/Options.js": [
		561,
		9,
		0,
		1,
		3,
		10,
		76
	],
	"./Quotelists/Modules/Quotelist/Options.scss": [
		1155,
		7,
		523
	],
	"./Quotelists/Modules/Quotelist/OptionsTableRow": [
		427,
		9,
		0,
		1,
		3,
		14,
		276
	],
	"./Quotelists/Modules/Quotelist/OptionsTableRow.js": [
		427,
		9,
		0,
		1,
		3,
		14,
		276
	],
	"./Quotelists/Modules/Quotelist/QuoteListButtons.scss": [
		1072,
		7,
		524
	],
	"./Quotelists/Modules/Quotelist/QuotelistButtons": [
		366,
		9,
		0,
		13,
		326
	],
	"./Quotelists/Modules/Quotelist/QuotelistButtons.js": [
		366,
		9,
		0,
		13,
		326
	],
	"./Quotelists/Modules/Quotelist/StocksETFsIndices": [
		537,
		9,
		0,
		1,
		3,
		13,
		259
	],
	"./Quotelists/Modules/Quotelist/StocksETFsIndices.js": [
		537,
		9,
		0,
		1,
		3,
		13,
		259
	],
	"./Quotelists/Modules/Quotelist/StocksETFsIndicesTableBuilders": [
		623,
		9,
		228
	],
	"./Quotelists/Modules/Quotelist/StocksETFsIndicesTableBuilders.js": [
		623,
		9,
		228
	],
	"./Quotelists/Modules/SelectWatchlist": [
		538,
		9,
		219
	],
	"./Quotelists/Modules/SelectWatchlist.js": [
		538,
		9,
		219
	],
	"./Quotelists/Modules/SelectWatchlist.scss": [
		1066,
		7,
		525
	],
	"./Quotelists/Modules/Watchlist/Estimates": [
		539,
		9,
		1,
		3,
		109
	],
	"./Quotelists/Modules/Watchlist/Estimates.js": [
		539,
		9,
		1,
		3,
		109
	],
	"./Quotelists/Modules/Watchlist/EstimatesTableBuilders/etfsTableBuilder": [
		429,
		9,
		1,
		3,
		151
	],
	"./Quotelists/Modules/Watchlist/EstimatesTableBuilders/etfsTableBuilder.js": [
		429,
		9,
		1,
		3,
		151
	],
	"./Quotelists/Modules/Watchlist/EstimatesTableBuilders/mutualFundsTableBuilder": [
		624,
		9,
		393
	],
	"./Quotelists/Modules/Watchlist/EstimatesTableBuilders/mutualFundsTableBuilder.js": [
		624,
		9,
		393
	],
	"./Quotelists/Modules/Watchlist/EstimatesTableBuilders/optionsTableBuilder": [
		625,
		9,
		394
	],
	"./Quotelists/Modules/Watchlist/EstimatesTableBuilders/optionsTableBuilder.js": [
		625,
		9,
		394
	],
	"./Quotelists/Modules/Watchlist/EstimatesTableBuilders/stocksAndIndicesTableBuilder": [
		428,
		9,
		1,
		3,
		152
	],
	"./Quotelists/Modules/Watchlist/EstimatesTableBuilders/stocksAndIndicesTableBuilder.js": [
		428,
		9,
		1,
		3,
		152
	],
	"./Quotelists/Modules/Watchlist/Fundamentals": [
		540,
		9,
		1,
		3,
		105
	],
	"./Quotelists/Modules/Watchlist/Fundamentals.js": [
		540,
		9,
		1,
		3,
		105
	],
	"./Quotelists/Modules/Watchlist/Fundamentals.scss": [
		1081,
		7,
		526
	],
	"./Quotelists/Modules/Watchlist/FundamentalsTableBuilders/etfsTableBuilder": [
		433,
		9,
		1,
		3,
		153
	],
	"./Quotelists/Modules/Watchlist/FundamentalsTableBuilders/etfsTableBuilder.js": [
		433,
		9,
		1,
		3,
		153
	],
	"./Quotelists/Modules/Watchlist/FundamentalsTableBuilders/mutualFundsTableBuilder": [
		432,
		9,
		1,
		3,
		170
	],
	"./Quotelists/Modules/Watchlist/FundamentalsTableBuilders/mutualFundsTableBuilder.js": [
		432,
		9,
		1,
		3,
		170
	],
	"./Quotelists/Modules/Watchlist/FundamentalsTableBuilders/optionsTableBuilder": [
		430,
		9,
		395
	],
	"./Quotelists/Modules/Watchlist/FundamentalsTableBuilders/optionsTableBuilder.js": [
		430,
		9,
		395
	],
	"./Quotelists/Modules/Watchlist/FundamentalsTableBuilders/stocksAndIndicesTableBuilder": [
		431,
		9,
		1,
		3,
		154
	],
	"./Quotelists/Modules/Watchlist/FundamentalsTableBuilders/stocksAndIndicesTableBuilder.js": [
		431,
		9,
		1,
		3,
		154
	],
	"./Quotelists/Modules/Watchlist/Performance": [
		541,
		9,
		1,
		3,
		107
	],
	"./Quotelists/Modules/Watchlist/Performance.js": [
		541,
		9,
		1,
		3,
		107
	],
	"./Quotelists/Modules/Watchlist/Performance.scss": [
		1156,
		7,
		527
	],
	"./Quotelists/Modules/Watchlist/PerformanceTableBuilders/mutualFundsTableBuilder": [
		436,
		9,
		1,
		3,
		171
	],
	"./Quotelists/Modules/Watchlist/PerformanceTableBuilders/mutualFundsTableBuilder.js": [
		436,
		9,
		1,
		3,
		171
	],
	"./Quotelists/Modules/Watchlist/PerformanceTableBuilders/optionsTableBuilder": [
		434,
		9,
		396
	],
	"./Quotelists/Modules/Watchlist/PerformanceTableBuilders/optionsTableBuilder.js": [
		434,
		9,
		396
	],
	"./Quotelists/Modules/Watchlist/PerformanceTableBuilders/stocksAndIndicesAndEtfsTableBuilder": [
		435,
		9,
		1,
		3,
		155
	],
	"./Quotelists/Modules/Watchlist/PerformanceTableBuilders/stocksAndIndicesAndEtfsTableBuilder.js": [
		435,
		9,
		1,
		3,
		155
	],
	"./Quotelists/Modules/Watchlist/Portfolio": [
		562,
		9,
		0,
		1,
		2,
		3,
		77
	],
	"./Quotelists/Modules/Watchlist/Portfolio.js": [
		562,
		9,
		0,
		1,
		2,
		3,
		77
	],
	"./Quotelists/Modules/Watchlist/Portfolio.scss": [
		1157,
		7,
		528
	],
	"./Quotelists/Modules/Watchlist/PortfolioTableBuilders/PortfolioRow": [
		438,
		9,
		0,
		1,
		2,
		3,
		103
	],
	"./Quotelists/Modules/Watchlist/PortfolioTableBuilders/PortfolioRow.js": [
		438,
		9,
		0,
		1,
		2,
		3,
		103
	],
	"./Quotelists/Modules/Watchlist/PortfolioTableBuilders/portfolioTableHelper": [
		437,
		9,
		378
	],
	"./Quotelists/Modules/Watchlist/PortfolioTableBuilders/portfolioTableHelper.js": [
		437,
		9,
		378
	],
	"./Quotelists/Modules/Watchlist/QuoteDetail": [
		542,
		9,
		1,
		3,
		23,
		272
	],
	"./Quotelists/Modules/Watchlist/QuoteDetail.js": [
		542,
		9,
		1,
		3,
		23,
		272
	],
	"./Quotelists/Modules/Watchlist/QuoteDetail.scss": [
		1158,
		7,
		529
	],
	"./Quotelists/Modules/Watchlist/QuoteDetailsTableBuilders/etfsTableBuilder": [
		463,
		9,
		1,
		3,
		23,
		373
	],
	"./Quotelists/Modules/Watchlist/QuoteDetailsTableBuilders/etfsTableBuilder.js": [
		463,
		9,
		1,
		3,
		23,
		373
	],
	"./Quotelists/Modules/Watchlist/QuoteDetailsTableBuilders/mutualFundsTableBuilder": [
		441,
		9,
		1,
		3,
		172
	],
	"./Quotelists/Modules/Watchlist/QuoteDetailsTableBuilders/mutualFundsTableBuilder.js": [
		441,
		9,
		1,
		3,
		172
	],
	"./Quotelists/Modules/Watchlist/QuoteDetailsTableBuilders/optionsTableBuilder": [
		439,
		9,
		1,
		3,
		173
	],
	"./Quotelists/Modules/Watchlist/QuoteDetailsTableBuilders/optionsTableBuilder.js": [
		439,
		9,
		1,
		3,
		173
	],
	"./Quotelists/Modules/Watchlist/QuoteDetailsTableBuilders/stocksAndIndicesTableBuilder": [
		440,
		9,
		1,
		3,
		156
	],
	"./Quotelists/Modules/Watchlist/QuoteDetailsTableBuilders/stocksAndIndicesTableBuilder.js": [
		440,
		9,
		1,
		3,
		156
	],
	"./Quotelists/Quotelist": [
		626,
		9,
		0,
		1,
		3,
		10,
		69
	],
	"./Quotelists/Quotelist.js": [
		626,
		9,
		0,
		1,
		3,
		10,
		69
	],
	"./Quotelists/Quotelist.scss": [
		1194,
		7,
		530
	],
	"./Quotelists/Watchlist": [
		627,
		9,
		0,
		1,
		2,
		3,
		68
	],
	"./Quotelists/Watchlist.js": [
		627,
		9,
		0,
		1,
		2,
		3,
		68
	],
	"./Quotelists/Watchlist.scss": [
		1195,
		7,
		531
	],
	"./SessionEnded/SessionEnded": [
		574,
		9,
		36
	],
	"./SessionEnded/SessionEnded.js": [
		574,
		9,
		36
	],
	"./SessionEnded/SessionEnded.scss": [
		1165,
		7,
		532
	],
	"./Shared/AddToWatchlist/AddToWatchlist": [
		377,
		9,
		0,
		13,
		358
	],
	"./Shared/AddToWatchlist/AddToWatchlist.js": [
		377,
		9,
		0,
		13,
		358
	],
	"./Shared/AddToWatchlist/AddToWatchlist.scss": [
		1100,
		7,
		533
	],
	"./Shared/AddToWatchlist/AddToWatchlistTable": [
		392,
		9,
		166
	],
	"./Shared/AddToWatchlist/AddToWatchlistTable.js": [
		392,
		9,
		166
	],
	"./Shared/ChartWorksChart/ChartWorksChart": [
		384,
		9,
		327
	],
	"./Shared/ChartWorksChart/ChartWorksChart.js": [
		384,
		9,
		327
	],
	"./Shared/ChartWorksChart/ChartWorksChart.scss": [
		1075,
		7,
		534
	],
	"./Shared/ComingSoon/ComingSoon": [
		628,
		9,
		0,
		5,
		279
	],
	"./Shared/ComingSoon/ComingSoon.js": [
		628,
		9,
		0,
		5,
		279
	],
	"./Shared/ComingSoon/ComingSoon.scss": [
		1196,
		7,
		535
	],
	"./Shared/CompareConfirmationModal/CompareConfimationModal": [
		418,
		9,
		0,
		201
	],
	"./Shared/CompareConfirmationModal/CompareConfimationModal.js": [
		418,
		9,
		0,
		201
	],
	"./Shared/CompareConfirmationModal/CompareConfirmationModal.scss": [
		1095,
		7,
		536
	],
	"./Shared/ConfirmationModal/ConfirmationModal": [
		534,
		9,
		0,
		235
	],
	"./Shared/ConfirmationModal/ConfirmationModal.js": [
		534,
		9,
		0,
		235
	],
	"./Shared/CurrencyConversion/CurrencyConversion": [
		457,
		9,
		133
	],
	"./Shared/CurrencyConversion/CurrencyConversion.js": [
		457,
		9,
		133
	],
	"./Shared/CurrencyConversion/CurrencyConversion.scss": [
		1099,
		7,
		537
	],
	"./Shared/ErrorBoundary/ErrorBoundary": [
		137,
		9
	],
	"./Shared/ErrorBoundary/ErrorBoundary.js": [
		137,
		9
	],
	"./Shared/ErrorBoundary/ErrorBoundary.scss": [
		266,
		7
	],
	"./Shared/LinkPdf/LinkPdf": [
		350,
		9,
		252
	],
	"./Shared/LinkPdf/LinkPdf.js": [
		350,
		9,
		252
	],
	"./Shared/Navigation/LinkedLabel": [
		342,
		9,
		397
	],
	"./Shared/Navigation/LinkedLabel.js": [
		342,
		9,
		397
	],
	"./Shared/Navigation/Navigation": [
		345,
		9,
		341
	],
	"./Shared/Navigation/Navigation.js": [
		345,
		9,
		341
	],
	"./Shared/Navigation/Navigation.scss": [
		1047,
		7,
		538
	],
	"./Shared/Navigation/SymbolTab": [
		629,
		9,
		362
	],
	"./Shared/Navigation/SymbolTab.js": [
		629,
		9,
		362
	],
	"./Shared/News/BuzzNews": [
		396,
		9,
		398
	],
	"./Shared/News/BuzzNews.js": [
		396,
		9,
		398
	],
	"./Shared/News/MarketNews.scss": [
		1151,
		7,
		539
	],
	"./Shared/News/MarketsNews": [
		462,
		9,
		2,
		30,
		206
	],
	"./Shared/News/MarketsNews.js": [
		462,
		9,
		2,
		30,
		206
	],
	"./Shared/News/RecentNews": [
		364,
		9,
		2,
		12,
		353
	],
	"./Shared/News/RecentNews.js": [
		364,
		9,
		2,
		12,
		353
	],
	"./Shared/News/RecentNews.scss": [
		1094,
		7,
		540
	],
	"./Shared/OptionChain/OptionChain": [
		361,
		9,
		0,
		1,
		3,
		10,
		101
	],
	"./Shared/OptionChain/OptionChain.js": [
		361,
		9,
		0,
		1,
		3,
		10,
		101
	],
	"./Shared/OptionChain/OptionChain.scss": [
		1059,
		7,
		541
	],
	"./Shared/OptionChain/OptionChainRow": [
		355,
		9,
		0,
		1,
		3,
		14,
		303
	],
	"./Shared/OptionChain/OptionChainRow.js": [
		355,
		9,
		0,
		1,
		3,
		14,
		303
	],
	"./Shared/OptionChain/OptionChainTable": [
		358,
		9,
		0,
		1,
		3,
		10,
		134
	],
	"./Shared/OptionChain/OptionChainTable.js": [
		358,
		9,
		0,
		1,
		3,
		10,
		134
	],
	"./Shared/OptionChain/OptionSymbolCell": [
		354,
		9,
		399
	],
	"./Shared/OptionChain/OptionSymbolCell.js": [
		354,
		9,
		399
	],
	"./Shared/OptionChain/OrderDetails": [
		353,
		9,
		0,
		14,
		352
	],
	"./Shared/OptionChain/OrderDetails.js": [
		353,
		9,
		0,
		14,
		352
	],
	"./Shared/OptionChain/SymbolOptionChain": [
		386,
		9,
		0,
		1,
		3,
		10,
		99
	],
	"./Shared/OptionChain/SymbolOptionChain.js": [
		386,
		9,
		0,
		1,
		3,
		10,
		99
	],
	"./Shared/PageNotFound/PageNotFound": [
		630,
		9,
		0,
		5,
		316
	],
	"./Shared/PageNotFound/PageNotFound.js": [
		630,
		9,
		0,
		5,
		316
	],
	"./Shared/PageWrapper/PageWrapper": [
		341,
		9,
		0,
		5,
		329
	],
	"./Shared/PageWrapper/PageWrapper.js": [
		341,
		9,
		0,
		5,
		329
	],
	"./Shared/PageWrapper/PageWrapper.scss": [
		1049,
		7,
		542
	],
	"./Shared/PdfDownload/PdfDownload": [
		631,
		9,
		183
	],
	"./Shared/PdfDownload/PdfDownload.js": [
		631,
		9,
		183
	],
	"./Shared/PdfDownload/PdfDownload.scss": [
		1197,
		7,
		543
	],
	"./Shared/PopupChart/PopupChart": [
		292,
		9,
		400
	],
	"./Shared/PopupChart/PopupChart.js": [
		292,
		9,
		400
	],
	"./Shared/PopupChart/PopupChart.scss": [
		1203,
		7,
		544
	],
	"./Shared/QuoteBar/MorningstarDrawer": [
		376,
		9,
		0,
		24,
		385
	],
	"./Shared/QuoteBar/MorningstarDrawer.js": [
		376,
		9,
		0,
		24,
		385
	],
	"./Shared/QuoteBar/QuoteBar": [
		385,
		9,
		0,
		1,
		4,
		24,
		261
	],
	"./Shared/QuoteBar/QuoteBar.js": [
		385,
		9,
		0,
		1,
		4,
		24,
		261
	],
	"./Shared/QuoteBar/QuoteBar.scss": [
		1078,
		7,
		545
	],
	"./Shared/QuoteBar/TodaysRange": [
		372,
		9,
		0,
		241
	],
	"./Shared/QuoteBar/TodaysRange.js": [
		372,
		9,
		0,
		241
	],
	"./Shared/QuoteDetails/QuoteDetails": [
		426,
		9,
		288
	],
	"./Shared/QuoteDetails/QuoteDetails.js": [
		426,
		9,
		288
	],
	"./Shared/QuoteDetails/QuoteDetails.scss": [
		1098,
		7,
		546
	],
	"./Shared/Screener/SaveScreenButton": [
		344,
		9,
		0,
		2,
		125
	],
	"./Shared/Screener/SaveScreenButton.js": [
		344,
		9,
		0,
		2,
		125
	],
	"./Shared/Screener/SaveScreenButton.scss": [
		1048,
		7,
		547
	],
	"./Shared/Screener/SavedScreens.scss": [
		1051,
		7,
		548
	],
	"./Shared/Screener/ScreenResultsMenu": [
		349,
		9,
		1,
		3,
		143
	],
	"./Shared/Screener/ScreenResultsMenu.js": [
		349,
		9,
		1,
		3,
		143
	],
	"./Shared/Screener/ScreenResultsMenu.scss": [
		1052,
		7,
		549
	],
	"./Shared/Screener/ScreenerCriteria": [
		632,
		9,
		0,
		1,
		2,
		4,
		64
	],
	"./Shared/Screener/ScreenerCriteria.js": [
		632,
		9,
		0,
		1,
		2,
		4,
		64
	],
	"./Shared/Screener/ScreenerResultsTable": [
		346,
		9,
		0,
		1,
		2,
		3,
		54
	],
	"./Shared/Screener/ScreenerResultsTable.js": [
		346,
		9,
		0,
		1,
		2,
		3,
		54
	],
	"./Shared/Screener/ScreenerResultsTable.scss": [
		1054,
		7,
		550
	],
	"./Shared/Screener/ScreenerViewOptions": [
		348,
		9,
		0,
		2,
		7,
		8,
		80
	],
	"./Shared/Screener/ScreenerViewOptions.js": [
		348,
		9,
		0,
		2,
		7,
		8,
		80
	],
	"./Shared/Screener/criteria/CriteriaComponentMap": [
		291,
		9,
		0,
		2,
		7,
		8,
		92
	],
	"./Shared/Screener/criteria/CriteriaComponentMap.js": [
		291,
		9,
		0,
		2,
		7,
		8,
		92
	],
	"./Shared/Screener/criteria/CriteriaRow": [
		343,
		9,
		0,
		1,
		2,
		4,
		66
	],
	"./Shared/Screener/criteria/CriteriaRow.js": [
		343,
		9,
		0,
		1,
		2,
		4,
		66
	],
	"./Shared/Screener/criteria/CriteriaRow.scss": [
		1053,
		7,
		551
	],
	"./Shared/Screener/criteria/FundStructureRow": [
		300,
		9,
		239
	],
	"./Shared/Screener/criteria/FundStructureRow.js": [
		300,
		9,
		239
	],
	"./Shared/Screener/criteria/FundamentalsRange": [
		327,
		9,
		2,
		209
	],
	"./Shared/Screener/criteria/FundamentalsRange.js": [
		327,
		9,
		2,
		209
	],
	"./Shared/Screener/criteria/LFAssetType": [
		332,
		9,
		160
	],
	"./Shared/Screener/criteria/LFAssetType.js": [
		332,
		9,
		160
	],
	"./Shared/Screener/criteria/LFFundPromotor": [
		333,
		9,
		145
	],
	"./Shared/Screener/criteria/LFFundPromotor.js": [
		333,
		9,
		145
	],
	"./Shared/Screener/criteria/LFLipperClassification": [
		334,
		9,
		146
	],
	"./Shared/Screener/criteria/LFLipperClassification.js": [
		334,
		9,
		146
	],
	"./Shared/Screener/criteria/LFTotalReturns1m": [
		335,
		9,
		190
	],
	"./Shared/Screener/criteria/LFTotalReturns1m.js": [
		335,
		9,
		190
	],
	"./Shared/Screener/criteria/LipperLeaderScreenerRow": [
		336,
		9,
		161
	],
	"./Shared/Screener/criteria/LipperLeaderScreenerRow.js": [
		336,
		9,
		161
	],
	"./Shared/Screener/criteria/LipperLeaderScreenerRow.scss": [
		1045,
		7,
		552
	],
	"./Shared/Screener/criteria/MSDAverageCreditQualityLong": [
		313,
		9,
		317
	],
	"./Shared/Screener/criteria/MSDAverageCreditQualityLong.js": [
		313,
		9,
		317
	],
	"./Shared/Screener/criteria/MSDAvg10DayVolume": [
		302,
		9,
		2,
		210
	],
	"./Shared/Screener/criteria/MSDAvg10DayVolume.js": [
		302,
		9,
		2,
		210
	],
	"./Shared/Screener/criteria/MSDCIBCETFType": [
		298,
		9,
		181
	],
	"./Shared/Screener/criteria/MSDCIBCETFType.js": [
		298,
		9,
		181
	],
	"./Shared/Screener/criteria/MSDCIBCSlowStochasticK3vsD3": [
		318,
		9,
		211
	],
	"./Shared/Screener/criteria/MSDCIBCSlowStochasticK3vsD3.js": [
		318,
		9,
		211
	],
	"./Shared/Screener/criteria/MSDCIBCSlowStochasticK3vsD3.scss": [
		1042,
		7,
		553
	],
	"./Shared/Screener/criteria/MSDDividendDistributionFrequency": [
		303,
		9,
		236
	],
	"./Shared/Screener/criteria/MSDDividendDistributionFrequency.js": [
		303,
		9,
		236
	],
	"./Shared/Screener/criteria/MSDDividendYieldPtile": [
		633,
		9,
		2,
		127
	],
	"./Shared/Screener/criteria/MSDDividendYieldPtile.js": [
		633,
		9,
		2,
		127
	],
	"./Shared/Screener/criteria/MSDDomicileCountry": [
		299,
		9,
		229
	],
	"./Shared/Screener/criteria/MSDDomicileCountry.js": [
		299,
		9,
		229
	],
	"./Shared/Screener/criteria/MSDEquityStyleBoxText": [
		308,
		9,
		318
	],
	"./Shared/Screener/criteria/MSDEquityStyleBoxText.js": [
		308,
		9,
		318
	],
	"./Shared/Screener/criteria/MSDFixedIncomeStyleBoxText": [
		309,
		9,
		319
	],
	"./Shared/Screener/criteria/MSDFixedIncomeStyleBoxText.js": [
		309,
		9,
		319
	],
	"./Shared/Screener/criteria/MSDFundFamilyName": [
		304,
		9,
		157
	],
	"./Shared/Screener/criteria/MSDFundFamilyName.js": [
		304,
		9,
		157
	],
	"./Shared/Screener/criteria/MSDFundShareClassNetAssets": [
		310,
		9,
		116
	],
	"./Shared/Screener/criteria/MSDFundShareClassNetAssets.js": [
		310,
		9,
		116
	],
	"./Shared/Screener/criteria/MSDFundShareClassNetAssets.scss": [
		1040,
		7,
		554
	],
	"./Shared/Screener/criteria/MSDInceptionDate": [
		316,
		9,
		203
	],
	"./Shared/Screener/criteria/MSDInceptionDate.js": [
		316,
		9,
		203
	],
	"./Shared/Screener/criteria/MSDLastClose": [
		305,
		9,
		2,
		338
	],
	"./Shared/Screener/criteria/MSDLastClose.js": [
		305,
		9,
		2,
		338
	],
	"./Shared/Screener/criteria/MSDMorningstarCategoryName": [
		306,
		9,
		158
	],
	"./Shared/Screener/criteria/MSDMorningstarCategoryName.js": [
		306,
		9,
		158
	],
	"./Shared/Screener/criteria/MSDNew52WeekHigh": [
		307,
		9,
		207
	],
	"./Shared/Screener/criteria/MSDNew52WeekHigh.js": [
		307,
		9,
		207
	],
	"./Shared/Screener/criteria/MSDNew52WeekLow": [
		311,
		9,
		208
	],
	"./Shared/Screener/criteria/MSDNew52WeekLow.js": [
		311,
		9,
		208
	],
	"./Shared/Screener/criteria/MSDTop10Holdings": [
		314,
		9,
		0,
		7,
		374
	],
	"./Shared/Screener/criteria/MSDTop10Holdings.js": [
		314,
		9,
		0,
		7,
		374
	],
	"./Shared/Screener/criteria/MorningstarStarGroupRow": [
		301,
		9,
		162
	],
	"./Shared/Screener/criteria/MorningstarStarGroupRow.js": [
		301,
		9,
		162
	],
	"./Shared/Screener/criteria/MorningstarStarGroupRow.scss": [
		1039,
		7,
		555
	],
	"./Shared/Screener/criteria/MovingAverageCrossOver": [
		315,
		9,
		237
	],
	"./Shared/Screener/criteria/MovingAverageCrossOver.js": [
		315,
		9,
		237
	],
	"./Shared/Screener/criteria/NetProfitMargin": [
		329,
		9,
		2,
		212
	],
	"./Shared/Screener/criteria/NetProfitMargin.js": [
		329,
		9,
		2,
		212
	],
	"./Shared/Screener/criteria/PtileReturnRow": [
		337,
		9,
		0,
		2,
		111
	],
	"./Shared/Screener/criteria/PtileReturnRow.js": [
		337,
		9,
		0,
		2,
		111
	],
	"./Shared/Screener/criteria/PtileReturnRow.scss": [
		1037,
		7,
		556
	],
	"./Shared/Screener/criteria/RUBeta5y": [
		324,
		9,
		191
	],
	"./Shared/Screener/criteria/RUBeta5y.js": [
		324,
		9,
		191
	],
	"./Shared/Screener/criteria/RUConsRecLabel": [
		330,
		9,
		205
	],
	"./Shared/Screener/criteria/RUConsRecLabel.js": [
		330,
		9,
		205
	],
	"./Shared/Screener/criteria/RUConsRecLabel.scss": [
		1043,
		7,
		557
	],
	"./Shared/Screener/criteria/RUExchangeCountry": [
		319,
		9,
		230
	],
	"./Shared/Screener/criteria/RUExchangeCountry.js": [
		319,
		9,
		230
	],
	"./Shared/Screener/criteria/RUMktCapUS": [
		320,
		9,
		2,
		213
	],
	"./Shared/Screener/criteria/RUMktCapUS.js": [
		320,
		9,
		2,
		213
	],
	"./Shared/Screener/criteria/RUPriceChange": [
		322,
		9,
		2,
		214
	],
	"./Shared/Screener/criteria/RUPriceChange.js": [
		322,
		9,
		2,
		214
	],
	"./Shared/Screener/criteria/RUPriceLast": [
		321,
		9,
		2,
		215
	],
	"./Shared/Screener/criteria/RUPriceLast.js": [
		321,
		9,
		2,
		215
	],
	"./Shared/Screener/criteria/RURevTTMUS": [
		328,
		9,
		2,
		216
	],
	"./Shared/Screener/criteria/RURevTTMUS.js": [
		328,
		9,
		2,
		216
	],
	"./Shared/Screener/criteria/RUTRBCIndustry": [
		326,
		9,
		159
	],
	"./Shared/Screener/criteria/RUTRBCIndustry.js": [
		326,
		9,
		159
	],
	"./Shared/Screener/criteria/RUTRBCSector": [
		325,
		9,
		178
	],
	"./Shared/Screener/criteria/RUTRBCSector.js": [
		325,
		9,
		178
	],
	"./Shared/Screener/criteria/RUVol10dAvg": [
		323,
		9,
		2,
		217
	],
	"./Shared/Screener/criteria/RUVol10dAvg.js": [
		323,
		9,
		2,
		217
	],
	"./Shared/Screener/criteria/RiskPtileRow": [
		312,
		9,
		2,
		128
	],
	"./Shared/Screener/criteria/RiskPtileRow.js": [
		312,
		9,
		2,
		128
	],
	"./Shared/Screener/criteria/STRSIPeriod2": [
		317,
		9,
		218
	],
	"./Shared/Screener/criteria/STRSIPeriod2.js": [
		317,
		9,
		218
	],
	"./Shared/Screener/criteria/STRSIPeriod2.scss": [
		1041,
		7,
		558
	],
	"./Shared/Screener/criteria/TopGlobalHoldingsRow": [
		339,
		9,
		0,
		2,
		112
	],
	"./Shared/Screener/criteria/TopGlobalHoldingsRow.js": [
		339,
		9,
		0,
		2,
		112
	],
	"./Shared/Screener/criteria/TopSectorHoldingsRow": [
		338,
		9,
		0,
		2,
		113
	],
	"./Shared/Screener/criteria/TopSectorHoldingsRow.js": [
		338,
		9,
		0,
		2,
		113
	],
	"./Shared/Screener/criteria/YearComparedToDollarAmount": [
		331,
		9,
		2,
		185
	],
	"./Shared/Screener/criteria/YearComparedToDollarAmount.js": [
		331,
		9,
		2,
		185
	],
	"./Shared/Screener/criteria/YearComparedToDollarAmount.scss": [
		1044,
		7,
		559
	],
	"./Shared/SetAlertsLink/SetAlertsLink": [
		340,
		9,
		382
	],
	"./Shared/SetAlertsLink/SetAlertsLink.js": [
		340,
		9,
		382
	],
	"./Shared/SetAlertsLink/SetAlertsLink.scss": [
		1204,
		7,
		560
	],
	"./Shared/SnapshotChart/SnapshotChart": [
		387,
		9,
		281
	],
	"./Shared/SnapshotChart/SnapshotChart.js": [
		387,
		9,
		281
	],
	"./Shared/SnapshotChart/SnapshotChart.scss": [
		1079,
		7,
		561
	],
	"./Shared/StringizedScreenerCriteria/StringizedScreenerCriteria": [
		347,
		9,
		0,
		2,
		7,
		8,
		79
	],
	"./Shared/StringizedScreenerCriteria/StringizedScreenerCriteria.js": [
		347,
		9,
		0,
		2,
		7,
		8,
		79
	],
	"./Shared/StringizedScreenerCriteria/StringizedScreenerCriteria.scss": [
		1050,
		7,
		562
	],
	"./Shared/TechnicalAnalysis/TechnicalAnalysis": [
		371,
		9,
		379
	],
	"./Shared/TechnicalAnalysis/TechnicalAnalysis.js": [
		371,
		9,
		379
	],
	"./Shared/TechnicalAnalysis/TechnicalAnalysis.scss": [
		1068,
		7,
		563
	],
	"./Shared/TradeLink/TradeLink": [
		290,
		9,
		376
	],
	"./Shared/TradeLink/TradeLink.js": [
		290,
		9,
		376
	],
	"./Shared/TradeLink/TradeLink.scss": [
		1205,
		7,
		564
	],
	"./StockCentre/CustomizeScreener": [
		634,
		9,
		0,
		1,
		2,
		3,
		42
	],
	"./StockCentre/CustomizeScreener.js": [
		634,
		9,
		0,
		1,
		2,
		3,
		42
	],
	"./StockCentre/Overview/Prescreens": [
		544,
		9,
		366
	],
	"./StockCentre/Overview/Prescreens.js": [
		544,
		9,
		366
	],
	"./StockCentre/Overview/SavedScreens": [
		545,
		9,
		6,
		314
	],
	"./StockCentre/Overview/SavedScreens.js": [
		545,
		9,
		6,
		314
	],
	"./StockCentre/Overview/SavedScreens.scss": [
		1159,
		7,
		565
	],
	"./StockCentre/Overview/TodaysTopSectors": [
		563,
		9,
		147
	],
	"./StockCentre/Overview/TodaysTopSectors.js": [
		563,
		9,
		147
	],
	"./StockCentre/Overview/TodaysTopSectors.scss": [
		1160,
		7,
		566
	],
	"./StockCentre/Screener": [
		635,
		9,
		0,
		1,
		2,
		3,
		44
	],
	"./StockCentre/Screener.js": [
		635,
		9,
		0,
		1,
		2,
		3,
		44
	],
	"./StockCentre/Screener/CriteriaCard": [
		546,
		9,
		2,
		177
	],
	"./StockCentre/Screener/CriteriaCard.js": [
		546,
		9,
		2,
		177
	],
	"./StockCentre/Screener/CriteriaCard.scss": [
		1161,
		7,
		567
	],
	"./StockCentre/Screener/CustomizeScreenerCriteria": [
		443,
		9,
		0,
		1,
		2,
		4,
		57
	],
	"./StockCentre/Screener/CustomizeScreenerCriteria.js": [
		443,
		9,
		0,
		1,
		2,
		4,
		57
	],
	"./StockCentre/Screener/CustomizeScreenerResults": [
		442,
		9,
		0,
		1,
		2,
		3,
		52
	],
	"./StockCentre/Screener/CustomizeScreenerResults.js": [
		442,
		9,
		0,
		1,
		2,
		3,
		52
	],
	"./StockCentre/Screener/CustomizeScreenerResults.scss": [
		1101,
		7,
		568
	],
	"./StockCentre/Screener/PreScreeners": [
		547,
		9,
		0,
		1,
		2,
		3,
		51
	],
	"./StockCentre/Screener/PreScreeners.js": [
		547,
		9,
		0,
		1,
		2,
		3,
		51
	],
	"./StockCentre/Screener/SavedScreenMenu": [
		445,
		9,
		0,
		1,
		3,
		202
	],
	"./StockCentre/Screener/SavedScreenMenu.js": [
		445,
		9,
		0,
		1,
		3,
		202
	],
	"./StockCentre/Screener/SavedScreens": [
		548,
		9,
		0,
		1,
		2,
		3,
		50
	],
	"./StockCentre/Screener/SavedScreens.js": [
		548,
		9,
		0,
		1,
		2,
		3,
		50
	],
	"./StockCentre/Screener/SavedScreens.scss": [
		1083,
		7,
		569
	],
	"./StockCentre/Screener/StocksCriteriaTable": [
		393,
		9,
		0,
		1,
		2,
		4,
		62
	],
	"./StockCentre/Screener/StocksCriteriaTable.js": [
		393,
		9,
		0,
		1,
		2,
		4,
		62
	],
	"./StockCentre/Screener/StocksCriteriaTable.scss": [
		1082,
		7,
		570
	],
	"./StockCentre/Screener/modules/PreScreensConfig": [
		394,
		9,
		0,
		2,
		7,
		8,
		90
	],
	"./StockCentre/Screener/modules/PreScreensConfig.js": [
		394,
		9,
		0,
		2,
		7,
		8,
		90
	],
	"./StockCentre/Screener/modules/PreScreensTable": [
		444,
		9,
		0,
		2,
		7,
		8,
		82
	],
	"./StockCentre/Screener/modules/PreScreensTable.js": [
		444,
		9,
		0,
		2,
		7,
		8,
		82
	],
	"./StockCentre/Screener/modules/PreScreensTable.scss": [
		1102,
		7,
		571
	],
	"./StockCentre/StockCentre.scss": [
		1067,
		7,
		572
	],
	"./StockCentre/StockCentreOverview": [
		636,
		9,
		0,
		6,
		294,
		5,
		271
	],
	"./StockCentre/StockCentreOverview.js": [
		636,
		9,
		0,
		6,
		294,
		5,
		271
	],
	"./StockCentre/StockCentreScreenerTest": [
		637,
		9,
		0,
		2,
		6,
		308,
		94
	],
	"./StockCentre/StockCentreScreenerTest.js": [
		637,
		9,
		0,
		2,
		6,
		308,
		94
	],
	"./StockCentre/StocksScreener": [
		543,
		9,
		0,
		1,
		2,
		3,
		45
	],
	"./StockCentre/StocksScreener.js": [
		543,
		9,
		0,
		1,
		2,
		3,
		45
	],
	"./StockCentre/StocksUpgradesDowngrades": [
		652,
		9,
		0,
		295,
		5,
		328
	],
	"./StockCentre/StocksUpgradesDowngrades.js": [
		652,
		9,
		0,
		295,
		5,
		328
	],
	"./Stocks/AnalystPriceTarget": [
		446,
		9,
		371
	],
	"./Stocks/AnalystPriceTarget.js": [
		446,
		9,
		371
	],
	"./Stocks/AnalystPriceTarget.scss": [
		1103,
		7,
		573
	],
	"./Stocks/Analysts": [
		638,
		9,
		361
	],
	"./Stocks/Analysts.js": [
		638,
		9,
		361
	],
	"./Stocks/Charts": [
		639,
		9,
		284
	],
	"./Stocks/Charts.js": [
		639,
		9,
		284
	],
	"./Stocks/Charts.scss": [
		1206,
		7,
		574
	],
	"./Stocks/Earnings": [
		640,
		9,
		1,
		4,
		19,
		340
	],
	"./Stocks/Earnings.js": [
		640,
		9,
		1,
		4,
		19,
		340
	],
	"./Stocks/Financials": [
		641,
		9,
		1,
		4,
		18,
		401
	],
	"./Stocks/Financials.js": [
		641,
		9,
		1,
		4,
		18,
		401
	],
	"./Stocks/Fundamentals": [
		642,
		9,
		9,
		264
	],
	"./Stocks/Fundamentals.js": [
		642,
		9,
		9,
		264
	],
	"./Stocks/Fundamentals.scss": [
		1200,
		7,
		575
	],
	"./Stocks/News": [
		643,
		9,
		2,
		12,
		320
	],
	"./Stocks/News.js": [
		643,
		9,
		2,
		12,
		320
	],
	"./Stocks/Options": [
		644,
		9,
		0,
		1,
		3,
		10,
		98
	],
	"./Stocks/Options.js": [
		644,
		9,
		0,
		1,
		3,
		10,
		98
	],
	"./Stocks/Reports": [
		645,
		9,
		16,
		180
	],
	"./Stocks/Reports.js": [
		645,
		9,
		16,
		180
	],
	"./Stocks/Snapshot": [
		646,
		9,
		2,
		331,
		12,
		250
	],
	"./Stocks/Snapshot.js": [
		646,
		9,
		2,
		331,
		12,
		250
	],
	"./Stocks/Snapshot.scss": [
		1201,
		7,
		576
	],
	"./Stocks/Stocks": [
		647,
		9,
		0,
		1,
		4,
		298,
		78
	],
	"./Stocks/Stocks.js": [
		647,
		9,
		0,
		1,
		4,
		298,
		78
	],
	"./Stocks/Stocks.scss": [
		1202,
		7,
		577
	],
	"./Stocks/TechnicalAnalysis": [
		648,
		9,
		348
	],
	"./Stocks/TechnicalAnalysis.js": [
		648,
		9,
		348
	],
	"./Stocks/modules/Earnings/AnalystOpinions": [
		549,
		9,
		370
	],
	"./Stocks/modules/Earnings/AnalystOpinions.js": [
		549,
		9,
		370
	],
	"./Stocks/modules/Earnings/AnalystOpinions.scss": [
		1162,
		7,
		578
	],
	"./Stocks/modules/Earnings/StockEarnings.scss": [
		1198,
		7,
		579
	],
	"./Stocks/modules/Earnings/StockEarningsChart": [
		571,
		9,
		1,
		4,
		19
	],
	"./Stocks/modules/Earnings/StockEarningsChart.js": [
		571,
		9,
		1,
		4,
		19
	],
	"./Stocks/modules/Earnings/StockEarningsHoverTable": [
		550,
		9,
		375
	],
	"./Stocks/modules/Earnings/StockEarningsHoverTable.js": [
		550,
		9,
		375
	],
	"./Stocks/modules/Earnings/util": [
		398,
		9,
		381
	],
	"./Stocks/modules/Earnings/util.js": [
		398,
		9,
		381
	],
	"./Stocks/modules/Financials/BalanceSheetTable": [
		553,
		9,
		402
	],
	"./Stocks/modules/Financials/BalanceSheetTable.js": [
		553,
		9,
		402
	],
	"./Stocks/modules/Financials/CashFlowTable": [
		552,
		9,
		403
	],
	"./Stocks/modules/Financials/CashFlowTable.js": [
		552,
		9,
		403
	],
	"./Stocks/modules/Financials/Financials": [
		573,
		9,
		1,
		4,
		18
	],
	"./Stocks/modules/Financials/Financials.js": [
		573,
		9,
		1,
		4,
		18
	],
	"./Stocks/modules/Financials/Financials.scss": [
		1199,
		7,
		580
	],
	"./Stocks/modules/Financials/IncomeStatementTable": [
		551,
		9,
		404
	],
	"./Stocks/modules/Financials/IncomeStatementTable.js": [
		551,
		9,
		404
	],
	"./Stocks/modules/Fundamentals/AdditionalPerShare": [
		453,
		9,
		349
	],
	"./Stocks/modules/Fundamentals/AdditionalPerShare.js": [
		453,
		9,
		349
	],
	"./Stocks/modules/Fundamentals/Dividend": [
		455,
		9,
		9,
		405
	],
	"./Stocks/modules/Fundamentals/Dividend.js": [
		455,
		9,
		9,
		405
	],
	"./Stocks/modules/Fundamentals/EarningsPerShare": [
		447,
		9,
		355
	],
	"./Stocks/modules/Fundamentals/EarningsPerShare.js": [
		447,
		9,
		355
	],
	"./Stocks/modules/Fundamentals/FinancialStrength": [
		450,
		9,
		9,
		406
	],
	"./Stocks/modules/Fundamentals/FinancialStrength.js": [
		450,
		9,
		9,
		406
	],
	"./Stocks/modules/Fundamentals/FundamentalsCompanyOverview": [
		555,
		9,
		289
	],
	"./Stocks/modules/Fundamentals/FundamentalsCompanyOverview.js": [
		555,
		9,
		289
	],
	"./Stocks/modules/Fundamentals/FundamentalsCompanyOverview.scss": [
		1163,
		7,
		581
	],
	"./Stocks/modules/Fundamentals/FundamentalsTables": [
		554,
		9,
		9,
		301
	],
	"./Stocks/modules/Fundamentals/FundamentalsTables.js": [
		554,
		9,
		9,
		301
	],
	"./Stocks/modules/Fundamentals/Management": [
		454,
		9,
		9,
		407
	],
	"./Stocks/modules/Fundamentals/Management.js": [
		454,
		9,
		9,
		407
	],
	"./Stocks/modules/Fundamentals/Profitability": [
		449,
		9,
		9,
		380
	],
	"./Stocks/modules/Fundamentals/Profitability.js": [
		449,
		9,
		9,
		380
	],
	"./Stocks/modules/Fundamentals/Revenue": [
		448,
		9,
		350
	],
	"./Stocks/modules/Fundamentals/Revenue.js": [
		448,
		9,
		350
	],
	"./Stocks/modules/Fundamentals/ShareRelated": [
		452,
		9,
		9,
		408
	],
	"./Stocks/modules/Fundamentals/ShareRelated.js": [
		452,
		9,
		9,
		408
	],
	"./Stocks/modules/Fundamentals/Valuation": [
		451,
		9,
		9,
		409
	],
	"./Stocks/modules/Fundamentals/Valuation.js": [
		451,
		9,
		9,
		409
	],
	"./Stocks/modules/Reports/LatestReports": [
		471,
		9,
		16,
		220
	],
	"./Stocks/modules/Reports/LatestReports.js": [
		471,
		9,
		16,
		220
	],
	"./Stocks/modules/Reports/LatestReports.scss": [
		1171,
		7,
		582
	],
	"./Stocks/modules/Reports/SymbolLink": [
		360,
		9,
		383
	],
	"./Stocks/modules/Reports/SymbolLink.js": [
		360,
		9,
		383
	],
	"./Stocks/modules/Snapshot/CompanyOverview": [
		395,
		9,
		368
	],
	"./Stocks/modules/Snapshot/CompanyOverview.js": [
		395,
		9,
		368
	],
	"./Stocks/modules/Snapshot/CompanyOverview.scss": [
		1084,
		7,
		583
	],
	"./Stocks/modules/Snapshot/PdfReports": [
		556,
		9,
		197
	],
	"./Stocks/modules/Snapshot/PdfReports.js": [
		556,
		9,
		197
	],
	"./Stocks/modules/Snapshot/PdfReports.scss": [
		1164,
		7,
		584
	],
	"./Stocks/modules/Snapshot/StocksNews": [
		456,
		9,
		2,
		12,
		330
	],
	"./Stocks/modules/Snapshot/StocksNews.js": [
		456,
		9,
		2,
		12,
		330
	],
	"./Stocks/modules/Snapshot/StocksNews.scss": [
		1104,
		7,
		585
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 351;
module.exports = webpackAsyncContext;